import { Emoji, UserSettings, WorkspaceSettings, ApplicationSettings } from '../types';

export const DEFAULT_USER_EMOJI: Emoji[] = [];
export const DEFAULT_WORKSPACE_EMOJI: Emoji[] = [];

export const DEFAULT_APPLICATION_EMOJI: Emoji[] = [
	{
		name: 'thumbsup',
		canDelete: false,
		utf8Emoji: '👍',
	},
	{
		name: 'smile',
		canDelete: false,
		utf8Emoji: '😄',
	},
	{
		name: 'smiley',
		canDelete: false,
		utf8Emoji: '😃',
	},
	{
		name: 'grin',
		canDelete: false,
		utf8Emoji: '😁',
	},
	{
		name: 'heart_eyes',
		canDelete: false,
		utf8Emoji: '😍',
	},
	{
		name: 'scared',
		canDelete: false,
		utf8Emoji: '😱',
	},
	{
		name: 'star_eyes',
		canDelete: false,
		utf8Emoji: '🤩',
	},
	{
		name: 'sweat_smile',
		canDelete: false,
		utf8Emoji: '😅',
	},
	{
		name: 'joy',
		canDelete: false,
		utf8Emoji: '😂',
	},
	{
		name: 'laughing',
		canDelete: false,
		utf8Emoji: '😆',
	},
	{
		name: 'angel',
		canDelete: false,
		utf8Emoji: '😇',
	},
	{
		name: 'blush',
		canDelete: false,
		utf8Emoji: '😊',
	},
	{
		name: 'sunglasses',
		canDelete: false,
		utf8Emoji: '😎',
	},
	{
		name: 'party',
		canDelete: false,
		utf8Emoji: '🥳',
	},
	{
		name: 'sad',
		canDelete: false,
		utf8Emoji: '😢',
	},
	{
		name: 'crying',
		canDelete: false,
		utf8Emoji: '😭',
	},
	{
		name: '+1',
		canDelete: false,
		utf8Emoji: '👍',
	},
	{
		name: 'thumbsdown',
		canDelete: false,
		utf8Emoji: '👎',
	},
	{
		name: '-1',
		canDelete: false,
		utf8Emoji: '👎',
	},
	{
		name: 'pray',
		canDelete: false,
		utf8Emoji: '🙏',
	},
	{
		name: 'horns',
		canDelete: false,
		utf8Emoji: '🤘',
	},
	{
		name: 'ok',
		canDelete: false,
		utf8Emoji: '👌',
	},
	{
		name: 'muscle',
		canDelete: false,
		utf8Emoji: '💪',
	},
	{
		name: 'wave',
		canDelete: false,
		utf8Emoji: '👋',
	},
	{
		name: 'clapping',
		canDelete: false,
		utf8Emoji: '👏',
	},
	{
		name: 'two-hands',
		canDelete: false,
		utf8Emoji: '🙌',
	},
	{
		name: 'slowboat',
		canDelete: false,
		utf8Emoji: '🚣',
	},
	{
		name: 'see-no-evil',
		canDelete: false,
		utf8Emoji: '🙈',
	},
	{
		name: 'frown',
		canDelete: false,
		utf8Emoji: '😦',
	},
	{
		name: 'angry',
		canDelete: false,
		utf8Emoji: '🤬',
	},
	{
		name: 'flower',
		canDelete: false,
		utf8Emoji: '🌻',
	},
	{
		name: 'heart',
		canDelete: false,
		utf8Emoji: '❤',
	},
	{
		name: 'hugging-face',
		canDelete: false,
		utf8Emoji: '🤗',
	},
	{
		name: 'shrug',
		canDelete: false,
		utf8Emoji: '🤷',
	},
	{
		name: 'face-palm',
		canDelete: false,
		utf8Emoji: '🤦',
	},
	{
		name: 'thinking',
		canDelete: false,
		utf8Emoji: '🤔',
	},
	{
		name: 'weary-face',
		canDelete: false,
		utf8Emoji: '😩',
	},
	{
		name: 'checkmark',
		canDelete: false,
		utf8Emoji: '✔️',
	},
	{
		name: 'heavy-checkmark',
		canDelete: false,
		utf8Emoji: '✅',
	},
];

export const DEFAULT_USER_SETTINGS: UserSettings = {
	themesMode: {
		key: 'mode',
		value: 'light',
		category: 'themes',
		type: 'color',
	},
	regionLanguage: {
		key: 'language',
		value: 'en-us',
		category: 'region',
		type: 'color',
	},
	regionTimezone: {
		key: 'timezone',
		value: 'auto',
		category: 'region',
		type: 'color',
	},
	regionSpellcheck: {
		key: 'spellcheck',
		value: 'on',
		category: 'region',
		type: 'on/off',
	},
	accessibilityAllowAnimation: {
		key: 'allow-animation',
		value: 'on',
		category: 'accessibility',
		type: 'on/off',
	},
	accessibilityZoom: {
		key: 'zoom',
		value: '100',
		category: 'accessibility',
		type: 'number',
	},
	notificationsNotifyMain: {
		key: 'notify-main',
		value: 'on',
		category: 'notifications',
		type: 'on/off',
	},
	notificationsNotifyThread: {
		key: 'notify-thread',
		value: 'off',
		category: 'notifications',
		type: 'on/off',
	},
	notificationsKeywords: {
		key: 'keywords',
		value: 'sjokolade bacon kake',
		category: 'notifications',
		type: 'string',
	},
	notificationsPreview: {
		key: 'preview',
		value: 'on',
		category: 'notifications',
		type: 'on/off',
	},
	notificationsMute: {
		key: 'mute',
		value: 'off',
		category: 'notifications',
		type: 'on/off',
	},
	notificationsSound: {
		key: 'sound',
		value: 'level-up-sound',
		category: 'notifications',
		type: 'color',
	},
};

export const DEFAULT_WORKSPACE_SETTINGS: WorkspaceSettings = {
	...DEFAULT_USER_SETTINGS,
	themesTheme: {
		key: 'theme',
		value: 'teal',
		category: 'themes',
		type: 'color',
	},
	themesMessages: {
		key: 'messages',
		value: 'dark',
		category: 'themes',
		type: 'color',
	},
};

export const DEFAULT_APPLICATION_SETTINGS: ApplicationSettings = {
	...DEFAULT_WORKSPACE_SETTINGS,
	awesome: {
		key: 'awesome',
		value: 'true',
		category: 'awesome',
		type: 'checkbox',
	},
};
